import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {namespacedTypeDescriptionKey, legacyTypeDescriptionKey} from "../utils/descriptionKeys";

export class SetAttributeLocalizationCommand extends CommandBase {
    uid: string;
    id: string;
    seedInstanceDescription: boolean;

    constructor(uid: string, id: string, seedInstanceDescription: boolean = false) {
        super();
        this.uid = uid;
        this.id = id;
        this.seedInstanceDescription = seedInstanceDescription;
    }

    execute(data: RemoteConstantsModel): boolean {
        // Instance name keyed by uid
        new ChangeLocalizationValuesCommand(this.uid, this.id).execute(data);
        // Shared type description — now keyed by the NAMESPACED key (derived from
        // this instance's uid namespace). Only create if neither the namespaced
        // nor the legacy bare key already exists (so we don't duplicate an
        // existing shared template during the migration window).
        const lang = Object.keys(data.localization)[0];
        const sharedKey = namespacedTypeDescriptionKey(this.uid, this.id);
        const legacyKey = legacyTypeDescriptionKey(this.id);
        if (lang && !(sharedKey in data.localization[lang]) && !(legacyKey in data.localization[lang])) {
            new ChangeLocalizationValuesCommand(sharedKey, `${this.id} description`).execute(data);
        }
        // Per-instance description keyed by uid, seeded from the shared one
        // (namespaced first, then legacy). Opt-in (rewards).
        if (this.seedInstanceDescription && lang) {
            const seed = data.localization[lang][sharedKey]
                ?? data.localization[lang][legacyKey]
                ?? `${this.id} description`;
            new ChangeLocalizationValuesCommand(`${this.uid}.description`, seed).execute(data);
        }
        return true;
    }
}
